import FlourishEmbedCustom from "@components/Embeds/FlourishEmbedCustom";
import { useIsClientOnly } from "@hooks/useIsClientOnly";
import { createEmbed } from "@routes/Article/components/ArticleParagraphElements/storyElement/embed/EmbedFactory";
import { EmbedType } from "@routes/Article/components/ArticleParagraphElements/utils/enums";
import { getEmbedType } from "@routes/Article/components/ArticleParagraphElements/utils/helpers";
import { ArticleStoryElementProps } from "@routes/Article/components/ArticleParagraphElements/utils/types";
import parse, { DOMNode, domToReact, Element } from "html-react-parser";

const Embed = ({
  bodyString,
}: ArticleStoryElementProps): React.ReactElement => {
  const isClientOnly = useIsClientOnly();

  const transformEmbed = createEmbed();

  const replaceEmbed = (
    node: DOMNode
  ): string | boolean | void | object | Element | null => {
    if (node.type !== "tag") return;

    const element = node;
    const embedType = getEmbedType(element);

    if (!embedType) return domToReact([node]);

    if (embedType === EmbedType.Flourish) {
      const el = node;
      const href = el.attribs["data-src"];

      return <FlourishEmbedCustom url={href} />;
    }

    const transformWithType = (child: DOMNode) =>
      transformEmbed(child, embedType);

    return <>{domToReact([node], { replace: transformWithType })}</>;
  };

  return (
    <>{isClientOnly ? parse(bodyString, { replace: replaceEmbed }) : null}</>
  );
};

export default Embed;
